import { render, staticRenderFns } from "./secondCardAllAlert.vue?vue&type=template&id=89ee2f76&scoped=true"
import script from "./secondCardAllAlert.vue?vue&type=script&lang=js"
export * from "./secondCardAllAlert.vue?vue&type=script&lang=js"
import style0 from "./secondCardAllAlert.vue?vue&type=style&index=0&id=89ee2f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ee2f76",
  null
  
)

export default component.exports